var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_4489)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#E42125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.169 36.7273V44H23.1605L19.4638 38.6662H19.3963V44H18.299V36.7273H19.3146L23.0149 42.0682H23.0824V36.7273H24.169ZM28.0353 44.1101C27.4979 44.1101 27.0351 43.9953 26.6468 43.7656C26.2609 43.5336 25.9627 43.2081 25.752 42.7891C25.5436 42.3677 25.4395 41.8741 25.4395 41.3082C25.4395 40.7495 25.5436 40.2571 25.752 39.831C25.9627 39.4048 26.2562 39.0722 26.6326 38.8331C27.0114 38.594 27.4541 38.4744 27.9608 38.4744C28.2685 38.4744 28.5668 38.5253 28.8556 38.6271C29.1445 38.7289 29.4037 38.8887 29.6333 39.1065C29.863 39.3243 30.0441 39.6072 30.1767 39.9553C30.3092 40.3009 30.3755 40.7211 30.3755 41.2159V41.5923H26.0396V40.7969H29.335C29.335 40.5175 29.2782 40.2701 29.1646 40.0547C29.051 39.8369 28.8912 39.6652 28.6852 39.5398C28.4816 39.4143 28.2425 39.3516 27.9679 39.3516C27.6696 39.3516 27.4092 39.425 27.1866 39.5717C26.9664 39.7161 26.796 39.9055 26.6752 40.1399C26.5569 40.3719 26.4977 40.6241 26.4977 40.8963V41.5178C26.4977 41.8823 26.5616 42.1925 26.6895 42.4482C26.8197 42.7038 27.0008 42.8991 27.2328 43.0341C27.4648 43.1667 27.7359 43.233 28.046 43.233C28.2472 43.233 28.4307 43.2045 28.5964 43.1477C28.7621 43.0885 28.9054 43.0009 29.0261 42.8849C29.1468 42.7689 29.2392 42.6257 29.3031 42.4553L30.3081 42.6364C30.2276 42.9323 30.0832 43.1915 29.8748 43.4141C29.6689 43.6342 29.4096 43.8059 29.0971 43.929C28.787 44.0497 28.4331 44.1101 28.0353 44.1101ZM32.2647 38.5455L33.4686 40.669L34.6831 38.5455H35.8443L34.1433 41.2727L35.8585 44H34.6973L33.4686 41.9616L32.2434 44H31.0787L32.7761 41.2727L31.1 38.5455H32.2647ZM39.4806 38.5455V39.3977H36.5012V38.5455H39.4806ZM37.3002 37.2386H38.362V42.3984C38.362 42.6044 38.3928 42.7595 38.4544 42.8636C38.5159 42.9654 38.5952 43.0353 38.6923 43.0732C38.7917 43.1087 38.8994 43.1264 39.0154 43.1264C39.1007 43.1264 39.1752 43.1205 39.2392 43.1087C39.3031 43.0968 39.3528 43.0874 39.3883 43.0803L39.5801 43.9574C39.5185 43.9811 39.4309 44.0047 39.3173 44.0284C39.2037 44.0545 39.0616 44.0687 38.8912 44.071C38.6118 44.0758 38.3514 44.026 38.1099 43.9219C37.8684 43.8177 37.6731 43.6567 37.524 43.4389C37.3748 43.2211 37.3002 42.9477 37.3002 42.6186V37.2386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7503 15.2867C19.7503 15.6845 19.9084 16.066 20.1897 16.3473C20.471 16.6286 20.8525 16.7867 21.2503 16.7867H33.1303L29.1903 20.7267C28.9254 21.011 28.7811 21.3871 28.788 21.7757C28.7948 22.1643 28.9523 22.5351 29.2271 22.8099C29.5019 23.0848 29.8727 23.2422 30.2613 23.249C30.6499 23.2559 31.026 23.1116 31.3103 22.8467L37.8103 16.3467C38.0912 16.0654 38.249 15.6842 38.249 15.2867C38.249 14.8892 38.0912 14.5079 37.8103 14.2267L31.3103 7.72668C31.173 7.57931 31.0074 7.46111 30.8234 7.37912C30.6394 7.29714 30.4408 7.25305 30.2394 7.2495C30.038 7.24595 29.8379 7.283 29.6511 7.35844C29.4644 7.43388 29.2947 7.54617 29.1523 7.68861C29.0098 7.83104 28.8975 8.00071 28.8221 8.18749C28.7467 8.37427 28.7096 8.57432 28.7132 8.77573C28.7167 8.97713 28.7608 9.17576 28.8428 9.35976C28.9248 9.54376 29.043 9.70936 29.1903 9.84668L33.1303 13.7867L21.2503 13.7867C20.4223 13.7867 19.7503 14.4587 19.7503 15.2867Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_4489",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_4489"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_4489",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveNextIcon);
export default __webpack_public_path__ + "static/media/ActiveNextIcon.030f8dac15fd507cef8481f337772da4.svg";
export { ForwardRef as ReactComponent };